import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClock, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { DialogNgbService, PipesModule, QuizModule } from '@motivforce/mx-library-angular';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { AddProductDialogComponent } from './components/add-product-dialog/add-product-dialog.component';
import { DetailsProductDialogComponent } from './components/details-product-dialog/details-product-dialog.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { FullCartDialogComponent } from './components/full-cart-dialog/full-cart-dialog.component';
import { PeriodEndedDialogComponent } from './components/period-ended-dialog/period-ended-dialog.component';
import { SpinWheelPrizeDialogComponent } from './components/spin-wheel-prize-dialog/spin-wheel-prize-dialog.component';
import { SubmitProofDialogComponent } from './components/submit-proof-dialog/submit-proof-dialog.component';
import { SubmitProofThankYouDialogComponent } from './components/submit-proof-thank-you-dialog/submit-proof-thank-you-dialog.component';
import { TermsConditionsAcceptDialogComponent } from './components/terms-conditions-accept-dialog/terms-conditions-accept-dialog.component';

@NgModule({
  declarations: [
    DialogComponent,
    TermsConditionsAcceptDialogComponent,
    SubmitProofDialogComponent,
    SpinWheelPrizeDialogComponent,
    SubmitProofThankYouDialogComponent,
    AddProductDialogComponent,
    DetailsProductDialogComponent,
    FullCartDialogComponent,
    PeriodEndedDialogComponent,
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    RouterModule,
    QuizModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    PipesModule,
  ],
  exports: [NgbModalModule],
})
export class DialogModule {
  constructor(private dialog: DialogNgbService, private iconlibrary: FaIconLibrary) {
    this.dialog.registerNotificationDialog(DialogComponent);
    this.dialog.registerErrorDialog(DialogComponent);
    this.dialog.registerWarningDialog(DialogComponent);
    this.dialog.registerValidationDialog(DialogComponent);

    this.dialog.registerFeatureDialog('termsConditionsAcceptDialog', TermsConditionsAcceptDialogComponent);
    this.dialog.registerFeatureDialog('submitProofDialog', SubmitProofDialogComponent);
    this.dialog.registerFeatureDialog('spinWheelPrizeDialog', SpinWheelPrizeDialogComponent);
    this.dialog.registerFeatureDialog('submitProofThankYouDialog', SubmitProofThankYouDialogComponent);
    this.dialog.registerFeatureDialog('addedProductDialog', AddProductDialogComponent);
    this.dialog.registerFeatureDialog('detailsProductDialog', DetailsProductDialogComponent);
    this.dialog.registerFeatureDialog('fullCartDialog', FullCartDialogComponent);
    this.dialog.registerFeatureDialog('periodEndedDialog', PeriodEndedDialogComponent);

    this.iconlibrary.addIcons(faClock, faTrash);
  }
}
